module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logs"
  }, [_c('md-table', {
    attrs: {
      "md-theme": "white"
    }
  }, _vm._l((_vm.logs), function(log) {
    return _c('md-table-row', {
      key: log.id
    }, [_c('md-table-cell', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(log.description)
      }
    })]), _c('md-table-cell', {
      staticClass: "time"
    }, [_vm._v(_vm._s(((log.created_at) ? _vm.moment(log.created_at, 'YYYY.MM.DD HH:mm:ss').format('DD-MM-YYYY HH:mm') : '')))])], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74508b51","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/logs.vue
// module id = 1193
// module chunks = 0